const KEY = "cart-upsells";
const MAX_UPSELLS = 9;

const getUpsells = async ({ handle, variantId }) => {
  const root = window.routes.root_url === "/" ? "" : window.routes.root_url;

  try {
    const text = await fetch(
      `${root}/products/${handle}?section_id=upsells-content&variant=${variantId}`,
    ).then((res) => res.text());

    const section = new DOMParser().parseFromString(text, "text/html");

    const newData = {
      ...JSON.parse(section.querySelector("[data-upsell-items]").innerHTML),
      savedAt: Date.now(),
    };

    return newData;
  } catch (error) {
    return null;
  }
};

const getData = async () => {
  try {
    const data = JSON.parse(localStorage.getItem(KEY)) || [];
    const now = Date.now();

    // 1 hour
    const expiry = 1000 * 60 * 60;

    const updatedItems = await Promise.all(
      Object.values(data).map(async (item) => {
        const { handle, variantId, savedAt, country, version } = item;

        const isCurrent =
          savedAt &&
          now - savedAt < expiry &&
          version === window.theme.product_card_version;

        if (country === window.theme.country && isCurrent) {
          return item;
        }

        return await getUpsells({ handle, variantId });
      }),
    );

    return Object.fromEntries(
      updatedItems.map((item) => [item.variantId, item]),
    );
  } catch (e) {
    return Promise.resolve({});
  }
};

const saveData = (data) => {
  localStorage.setItem(KEY, JSON.stringify(data));
};

class MiniCartUpsells extends HTMLElement {
  constructor() {
    super();

    this._onCartUpdate = (e) => this._populate(e.detail.cartData);
    this._populate(window.cartData);
  }

  connectedCallback() {
    document.addEventListener("cart:updated", this._onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener("cart:updated", this._onCartUpdate);
  }

  _populate(cartData) {
    if (!cartData.items) return;

    const cartItemHandles = {};

    getData()
      .then((data) => {
        return Promise.all(
          cartData.items.map(async (item) => {
            cartItemHandles[item.handle] = true;
            if (item.variant_id in data) {
              return data[item.variant_id];
            }

            return getUpsells({
              handle: item.handle,
              variantId: item.variant_id,
            });
          }),
        );
      })
      .then((upsells) => {
        saveData(
          Object.fromEntries(upsells.map((item) => [item.variantId, item])),
        );

        const upsellItems = upsells
          .flatMap(({ items }) => items)
          .filter(({ handle }) => !(handle in cartItemHandles))
          .filter(
            ({ handle }, i, upsells) =>
              upsells.findIndex((item) => item.handle === handle) === i,
          )
          .slice(0, MAX_UPSELLS);

        const contentWrapper = this.querySelector("[data-upsells-container]");
        const carouselTemplate = this.querySelector("template").cloneNode(true);
        const carousel =
          carouselTemplate.content.querySelector(".swiper-wrapper");

        if (upsellItems.length) {
          carousel.innerHTML = upsellItems
            .map((item) => item.itemMarkup)
            .join("");

          contentWrapper.innerHTML = "";
          contentWrapper.append(carouselTemplate.content);

          this.style.display = null;
        } else {
          contentWrapper.innerHTML = "";
          this.style.display = "none";
        }
      });
  }
}

if (!customElements.get("mini-cart-upsells")) {
  customElements.define("mini-cart-upsells", MiniCartUpsells);
}
